import { render, staticRenderFns } from "./PriceContent.vue?vue&type=template&id=780741b5&scoped=true&"
import script from "./PriceContent.vue?vue&type=script&lang=js&"
export * from "./PriceContent.vue?vue&type=script&lang=js&"
import style0 from "./PriceContent.vue?vue&type=style&index=0&id=780741b5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780741b5",
  null
  
)

export default component.exports